import { en, vi } from 'vuetify/locale';

const locales = { en, vi };

if (locales.vi.timePicker) {
	locales.vi.timePicker.title = 'Chọn giờ';
}

export default locales;
